module.exports = __webpack_public_path__ + "img/corrupted_ent_small.aee32eda.png";